import React from 'react';
import { ConfigProvider, Spin, Space, App } from 'antd';
import { createStyles } from 'antd-style';
import zhCN from 'antd/locale/zh_CN';
import { Animation } from '@/components';
import { Animate } from '@/components/animation';

const useStyles = createStyles(({ css }): any => {
    return {
        body: css`
            padding: 10px;
        `,
        load: {
            margin: '0 auto',
            width: '100%',
            lineHeight: '100vh',
            background: '#fff',
            '.ant-spin-dot': {
                height: '300px',
                width: '300px',
                marginTop: '180px',
                zIndex: 999,
            },
        },
        gutter: {
            display: 'flex',
        },
    };
});

export type BodyProps = {
    loading?: boolean; // 是否加载状态
    space?: boolean; // 是否开启间距
    animation?: boolean; // 动画
    style?: any; // 样式
    className?: any; // 样式名
    children?: any; // 子内容
    bodyStyle?: any; // body样式
};

const Body: React.FC<BodyProps> = (props) => {
    const {
        children,
        loading,
        className,
        space = true,
        animation = true,
        bodyStyle,
    } = props;
    const { styles: { body, load, gutter } } = useStyles();

    return (
        <ConfigProvider locale={zhCN}>
            <App>
                {(loading && <Spin spinning={true} fullscreen size="large" className={load}></Spin>) || (
                    <div className={className ? className : body} style={bodyStyle}>
                        <Animation animate={animation ? Animate.FadeDown : Animate.None}>
                            {(space && (
                                    <Space direction="vertical" size="middle" className={gutter}>
                                        {children}
                                    </Space>
                                )) ||
                                children}
                        </Animation>
                    </div>
                )}
            </App>
        </ConfigProvider>
    );
};

export default Body;

